
import {Component, Vue} from 'vue-property-decorator';
import {IExternalUser} from '@/interfaces/external_user';
import {rules, stringToNumber} from '@/utils';
import {dispatchRegisterExternalUser} from '@/store/main/actions';
import LZString from 'lz-string';
import {commitAddNotification} from '@/store/main/mutations';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import FileUpload from '@/components/forms/FileUpload.vue';

import {appName} from '@/env';

@Component({
  components: {FileUpload, DefaultHelp},
})
export default class ExternalUserRegister extends Vue {
  private externalUser: IExternalUser = {} as IExternalUser;
  private email2: string = '';
  private valid: boolean = true;
  private rules: any = rules;
  private fileModel: any = null;
  private fileModelPersonal: any = null;

  private appName = appName;

  public cancel() {
    this.$router.back();
  }

  public async save() {
    const form: any = this.$refs.form_crud_user;
    if (!form.validate()) {
      return;
    }

    const userToCreate = {
      ...this.externalUser,
      cpf: stringToNumber(this.externalUser.cpf)
    }

    const userCreated = await dispatchRegisterExternalUser(this.$store, userToCreate);
    if (userCreated) {
      await this.$router.push('/login');
    }
  }

  public changeDocument(val) {
    this.externalUser.document = val;
  }

  public changePersonalDocument(val) {
    this.externalUser.personal_document = val;
  }

  private async toBase64(value) {
    let fileInfos = {};
    if (value instanceof Blob) {

      if (value.type !== 'application/pdf') {
        commitAddNotification(this.$store, {
          content: `${this.$t('infos.invalid_file_type')} PDF.`,
          color: 'error',
        });
        this.fileModel = null;
        return;
      }

      const converted = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

      // @ts-ignore
      const compressed = LZString.compressToUTF16(converted).trim();

      fileInfos = {
        // @ts-ignore
        name: value.name,
        type: value.type,
        compressed_size: compressed.length,
        original_size: value.size,
        data_base64: compressed,
        form_files_id: 0,
      };
    }
    this.externalUser.document = fileInfos;
  }

}
